import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { type APIResponse, type ContactNoteComment } from "@/lib/types";
import { baseContactRoute } from "./contact";

export const createContactNoteCommentV1 = (
  data: Pick<ContactNoteComment, "contactId" | "noteId" | "message"> &
    Partial<ContactNoteComment>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<ContactNoteComment>
    >(`${baseContactRoute}/notes/comments`, data)
    .then((res) => res.data);
};

type UpdateContactNoteCommentInput = Pick<
  ContactNoteComment,
  "id" | "dateModified" | "contactId" | "noteId" | "message"
> &
  Partial<ContactNoteComment>;

export const updateContactNoteCommentV1 = (
  data: UpdateContactNoteCommentInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<ContactNoteComment>
    >(`${baseContactRoute}/notes/comments`, data)
    .then((res) => res.data);
};

export const deleteContactNoteCommentV1 = (
  data: Pick<ContactNoteComment, "id" | "contactId" | "noteId">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<ContactNoteComment>
    >(`${baseContactRoute}/notes/comments/${data.id}`)
    .then((res) => res.data);
};
